import React, {Component} from 'react';
import Actionbar from "../Common/Actionbar";
import Navbar from "../Common/Navbar";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {
    faSignOutAlt,
    faAngleLeft,
    /*     faMapMarker,

        faAt,
       faCheckSquare,
       faLightbulb ,
       faShareAlt,*/
    faUserEdit,
    faWallet ,
    /*    faPhone,
    faShoppingCart,
    faStoreAlt*/

} from '@fortawesome/free-solid-svg-icons'
import NoPic from "../../assets/images/emptypic.png"
import API from "../../services/API";

const currencyFormat = Intl.NumberFormat('en-US');
class Profile extends Component {
    state ={
        user:[],
        cartItemCount : 0
    }
    onExitClick = () => {
        localStorage.clear();
        document.cookie = "auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        window.location.replace("/")
    }
    render() {
        return (
            <React.Fragment>
                <Actionbar noBack={1} title=' پروفایل' cartItemCount={this.state.cartItemCount} />
                <main className="container-fluid my-4 py-3">
                    <div className="row px-3 mt-4">
                        <div className="col-12 rtl profile-header" onClick={()=>this.props.history.push('/edit-profile') }>
                            <div className="card-body pt-4">
                                <div className="row" >
                                    <div className="col-3">
                                        <img src={this.state.user.avatar ? this.state.user.avatar : NoPic } className="rounded-circle mx-auto d-block" alt={this.state.user.first_name} width="70px" height="70px"/>
                                    </div>
                                    <div className="col-9">
                                        <div className=" fw-bold pt-2">{this.state.user.first_name} {this.state.user.last_name}</div>
                                        <span className=" super-small-2 ltr">
                                            {this.state.user.mobile ? this.state.user.mobile.replace('+98' , '0') : ''}
                                        </span>
                                        <div className="profile-edit-user">
                                            ویرایش
                                            &nbsp;
                                            <FontAwesomeIcon icon={faUserEdit} className='text-big' />
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>

                    </div>
                    <div className="container-fluid profile-list-items">
                        {/* <div className="row mt-4 rtl px-4 menu-list-item" onClick={()=>this.props.history.push('/marketers-map')} >

                            <div className="col-1">
                                <FontAwesomeIcon icon={faMapMarker} className="text-secondary"/>
                            </div>
                            <div className="col-10 text-dark menu-text ">
                               مشاهده بازاریاب ها روی نقشه

                            </div>
                            <div className="col-1">
                                <FontAwesomeIcon icon={faAngleLeft} />
                            </div>

                        </div>*/}
                        {/*     <div className="row mt-4 rtl px-4 menu-list-item" onClick={()=>this.props.history.push('/orders')} >

                            <div className="col-1">
                                <FontAwesomeIcon icon={faShoppingCart} className="text-secondary"/>
                            </div>
                            <div className="col-10 text-dark menu-text ">
                                تاریخچه سفارش ها
                                <div className="badge bg-secondary-color mx-2">
                                    {
                                        this.state.orders_number ?
                                            this.state.orders_number + ' سفارش ' :'' }


                                </div>
                            </div>
                            <div className="col-1">
                                <FontAwesomeIcon icon={faAngleLeft} />
                            </div>

                        </div>
                        <div className="row mt-4 rtl px-4 menu-list-item" onClick={()=>this.props.history.push('/invite')} >

                            <div className="col-1">
                                <FontAwesomeIcon icon={faShareAlt} className="text-secondary"/>
                            </div>
                            <div className="col-10 text-dark menu-text ">
                                معرفی اپلیکیشن به دوستان
                            </div>
                            <div className="col-1">
                                <FontAwesomeIcon icon={faAngleLeft} />
                            </div>

                        </div>
                        <div className="row mt-4 rtl px-4 menu-list-item" onClick={()=>this.props.history.push('/addresses')} >

                            <div className="col-1">
                                <FontAwesomeIcon icon={faMapMarker} className="text-secondary"/>
                            </div>
                            <div className="col-10 text-dark menu-text ">
                                مدیریت آدرس ها
                            </div>
                            <div className="col-1">
                                <FontAwesomeIcon icon={faAngleLeft} />
                            </div>

                        </div>

                        <div className="row mt-4 rtl px-4 menu-list-item" onClick={()=>this.props.history.push('/introduce/market')} >

                            <div className="col-1">
                                <FontAwesomeIcon icon={faStoreAlt} className="text-primary-color"/>
                            </div>
                            <div className="col-10 text-dark menu-text ">
                                معرفی فروشگاه
                            </div>
                            <div className="col-1">
                                <FontAwesomeIcon icon={faAngleLeft} />
                            </div>

                        </div>
                        <div className="row mt-4 rtl px-4 menu-list-item" onClick={()=>this.props.history.push('/contents/about')} >

                            <div className="col-1">
                                <FontAwesomeIcon icon={faAt} className="text-secondary"/>
                            </div>
                            <div className="col-10 text-dark menu-text ">
                                درباره ما
                            </div>
                            <div className="col-1">
                                <FontAwesomeIcon icon={faAngleLeft} />
                            </div>

                        </div>
                        <div className="row mt-4 rtl px-4 menu-list-item" onClick={()=>this.props.history.push('/contents/contact')} >

                            <div className="col-1">
                                <FontAwesomeIcon icon={faPhone} className="text-secondary"/>
                            </div>
                            <div className="col-10 text-dark menu-text ">
                                تماس ما
                            </div>
                            <div className="col-1">
                                <FontAwesomeIcon icon={faAngleLeft} />
                            </div>

                        </div>
                        <div className="row mt-4 rtl px-4 menu-list-item" onClick={()=>this.props.history.push('/contents/rules')}  >

                            <div className="col-1">
                                <FontAwesomeIcon icon={faCheckSquare} className="text-secondary"/>
                            </div>
                            <div className="col-10 text-dark menu-text ">
                                قوانین و مقررات
                            </div>
                            <div className="col-1">
                                <FontAwesomeIcon icon={faAngleLeft} />
                            </div>

                        </div>
                        <div className="row mt-4 rtl px-4 menu-list-item" onClick={()=>this.props.history.push('/contents/guide')} >

                            <div className="col-1">
                                <FontAwesomeIcon icon={faLightbulb} className="text-secondary"/>
                            </div>
                            <div className="col-10 text-dark menu-text ">
                                راهنمای اپلیکیشن
                            </div>
                            <div className="col-1">
                                <FontAwesomeIcon icon={faAngleLeft} />
                            </div>

                        </div>*/}
                       {/* <div className="row mt-4 rtl px-4 menu-list-item" onClick={()=>this.props.history.push('/orders-report')} >

                            <div className="col-1">
                                <FontAwesomeIcon icon={faList} className="text-secondary"/>
                            </div>
                            <div className="col-10 text-dark menu-text ">
                                گزارش عملکرد

                            </div>
                            <div className="col-1">
                                <FontAwesomeIcon icon={faAngleLeft} />
                            </div>

                        </div>*/}
                        <div className="row mt-4 rtl px-4 menu-list-item" onClick={()=>this.props.history.push('/wallet')} >

                            <div className="col-1">
                                <FontAwesomeIcon icon={faWallet} className="text-secondary"/>
                            </div>
                            <div className="col-10 text-dark menu-text " >
                                مدیریت  کیف پول
                                <div className="badge bg-secondary mx-2">
                                    {currencyFormat.format(this.state.wallet_inventory)}
                                    &nbsp;
                                    {window.localStorage.getItem("currency_unit")}
                                </div>
                            </div>
                            <div className="col-1">
                                <FontAwesomeIcon icon={faAngleLeft} />
                            </div>

                        </div>
                        <div className="row mt-4 rtl px-4 menu-list-item border-bottom-0" onClick={this.onExitClick}>

                            <div className="col-1">
                                <FontAwesomeIcon icon={faSignOutAlt} className="text-secondary"/>
                            </div>
                            <div className="col-10 text-dark menu-text ">
                                خروج از حساب کاربری
                            </div>
                            <div className="col-1">
                                <FontAwesomeIcon icon={faAngleLeft} />
                            </div>

                        </div>
                    </div>
                </main>
                <Navbar  />
            </React.Fragment>
        );
    }
    componentDidMount = () => {

        API.index()
            .then((response) => {
                window.localStorage.setItem("currency_unit", response.results.currency_unit.symbol);
                this.setState(response.results)
            })
    }
}

export default Profile;
